import { ERROR_CODES } from '../conf/errors';

export type UiError = {
  code: number;
  message: string;
  devMsg?: string | null;
};

const getErrorCodeMsg = (code: number) => {
  let msg = ERROR_CODES[code];
  if (!msg) {
    msg = `Unkown error`;
  }
  return `[${code}] ${msg}`;
};
export default getErrorCodeMsg;

export const getErrorMessage = (err: UiError) => `[${err.code}] ${err.message}`;
